export default __webpack_public_path__ + "static/media/UNISON-logo-white.428b4cf9.svg";